import React from 'react';
import { Box } from '@mui/material';

import { Button, Typography } from '@occc/ui-design-system';
import { ProductGroupFragment } from '@occc/graphql';

import { ProductGroupDetails } from './ProductGroupDetails';
import { OnSelectExistingProductGroup } from './types';

import { FormLabel } from '../../../FormLabel';
import { Column } from '../../../Column';

interface IExistingProductGroupsProps {
  existingProductGroups?: ProductGroupFragment[];
  onSelectExisting: OnSelectExistingProductGroup;
}

export const ExistingProductGroups: React.FC<IExistingProductGroupsProps> = ({
  existingProductGroups,
  onSelectExisting,
}) => {
  let details;

  if (!existingProductGroups || (existingProductGroups && existingProductGroups.length === 0)) {
    details = (
      <Column>
        <Typography>No duplicated Product Groups for this configuration.</Typography>
      </Column>
    );
  } else {
    details =
      existingProductGroups &&
      existingProductGroups.map((group) => {
        const onClick = () => {
          onSelectExisting(group);
        };
        return (
          <Column key={group.id}>
            <ProductGroupDetails productGroup={group} />
            <Button variant='contained' size='small' onClick={onClick}>
              Select
            </Button>
          </Column>
        );
      });
  }

  return (
    <Box>
      <FormLabel>Duplicate Product Groups</FormLabel>
      <Box display='flex' flexDirection='row'>
        {details}
      </Box>
    </Box>
  );
};
